import { Fancybox } from "@fancyapps/ui";
import Cookies from 'js-cookie';

const POPUP_TIMER_MS = 5000;  // Таймер для открытия попапа
const COOKIE_EXPIRY_DAYS = 1; // Время действия куки в сутках
const COOKIE_NAME = 'modal_slide_show';

const modalSlide = () => {
    if (Cookies.get(COOKIE_NAME)) return;

    setTimeout(function(){
        // Если в данный момент не открыто никакого другого попапа
        if (!document.documentElement.classList.contains('with-fancybox')){
            try {
                new Fancybox(
                    [{
                        src : '/modal_slide/',
                        type : 'ajax'
                    }]
                );
                Cookies.set(COOKIE_NAME, 'true', { expires: COOKIE_EXPIRY_DAYS });
            } catch (error) {
                console.error('Fancybox modalSlide initialization error:', error);
            }
        }
    },POPUP_TIMER_MS);
}

export default modalSlide;